import formatPeriodLabel from './formatPeriodLabel'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
//
// A deep-analysis section that shows two periods computes one summary per
// period. Decca must get them apart — publishing each under the same key
// lets the last one win. Not comparing: the single summary, with a `periode`
// label when a period is chosen (all data: exactly the shape it always had). Comparing: {A, B}, each tagged with its period.
// Null until every shown period has its summary, so nothing half is sent.

/**
 * @param {{A?: object|null, B?: object|null}} summaries - Per-side summaries (undefined/null = not ready)
 * @param {{compareActive: boolean, rangeA: object|null, rangeB: object|null}|null} period - From DeepAnalysisPeriodContext
 * @returns {object|null}
 */
const sideSummariesForAI = (summaries, period) => {
    const a = summaries?.A ?? null
    if (!period?.compareActive) {
        // One chosen period: still say which, or Decca presents the numbers
        // as covering all data (/complete review 2026-10-28).
        return a && period?.rangeA ? { periode: formatPeriodLabel(period.rangeA), ...a } : a
    }
    const b = summaries?.B ?? null
    if (!a || !b) return null
    return {
        A: { periode: formatPeriodLabel(period.rangeA), ...a },
        B: { periode: formatPeriodLabel(period.rangeB), ...b },
    }
}

export default sideSummariesForAI
